import { ArrowBack } from "@mui/icons-material";
import { Box, Typography, Button, Stack, Grid, FormControl, InputLabel, OutlinedInput, Select, MenuItem } from "@mui/material";
import { useContext, useEffect, useState } from "react";
import ReferralClientEnrolmentContext from "./referral-client-enrolment-context";
import { DateField } from "@mui/x-date-pickers";
import BasicDateField from "../../Common/BasicDateField";
import { userProfileData } from "../../Common/profileInfo";
import { clientConfig } from "../../awsClientConfig";
import { GetProfile } from "../../queries/getProfile";
import { GetProfilePrimaryAddress } from "../../queries/GetProfilePrimaryAddress";
import { Option } from "../core/option";
import { US_STATES } from "../../Common/States";  
import dayjs from "dayjs";
import { UpdateProfile } from "../../queries/updateProfile";
import { UpsertProfilePrimaryAddress } from "../../queries/UpsertProfilePrimaryAddress";
import { createEnrollmentAction } from "../../queries/CreateEnrollmentAction";
import { formatPhone, formatZipcode, hideFormatSSN } from "../../functions/misc";
import moment from "moment";
import Message from "../Message";
import Loading from "../../Common/Loading";
import Footer from "../footer";

const ProfileInformation = () => {
  const { previous, enrollmentId, setNextFormId, setS3Key, setS3Bucket, next, setCurrentStep } = useContext(ReferralClientEnrolmentContext);
  const client = new clientConfig();
  const [profileInfo, setProfileInfo] = useState<any>();
  const [addressInfo, setAddressInfo] = useState<any>({});
  const [hideSocialSecurity, SetHideSocialSecurity] = useState("");
  const [loading, setLoading] = useState(false);

  const [formProfileData, setFormProfileData] = useState<any>({});
  const [formAddressData, setFormAddressData] = useState<any>({});
  const [error, setError] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    dob: "",
    ssn: "",
    streetAddress1: "",
    city: "",
    state: "",
    zipCode: "",
  });
  const momentTz = require('moment-timezone');
  const pstDate = momentTz().tz("America/Los_Angeles");
  const pstCurrentDate = pstDate.year(pstDate.year() - 18);


  useEffect(() => {
    getProfile();
    getProfilePrimaryAddress();
  }, []);

  const getProfile = async () => {
    const profileId = await userProfileData();
    client
      .query({
        query: GetProfile,
        variables: { profileId: profileId },
      })
      .then((res: any) => {
        if (res.data.GetProfile !== null) {
            const profileData = res.data.GetProfile;
            setProfileInfo(res.data.GetProfile);
            setFormProfileData({
              firstName: profileData.FirstName,
              middleName: profileData.MiddleName,
              lastName: profileData.LastName,
              email: profileData.Email,
              phone: formatPhone(profileData.Phone),
              dob: profileData.Birthdate,
              ssn: hideFormatSSN(profileData.Ssn)
            });
            SetHideSocialSecurity(profileData.Ssn || "");
        }
          
      })
      .catch((error: any) => {
        console.log(error, "error");
      });
  };
  const getProfilePrimaryAddress = async () => {
    const profileId = await userProfileData();
    client
      .query({
        query: GetProfilePrimaryAddress,
        variables: { profileId: profileId },
      })
      .then((res: any) => {
        if (res.data.GetProfilePrimaryAddress !== null) {
          const primaryAddress = res.data.GetProfilePrimaryAddress;
          setAddressInfo(primaryAddress);
          setFormAddressData({
            streetAddress1: primaryAddress.StreetAddress1,
            streetAddress2: primaryAddress.StreetAddress2,
            city: primaryAddress.City,
            state: primaryAddress.State,
            zipCode: primaryAddress.ZipCode,
          });
        }
      })
      .catch((error: any) => {
        console.log(error, "error");
      });
  };

  const formatPhoneNumber = (e: any) => {
    const str = e.target.value;
    const phoneNumber = str.replace(/[^\d]/g, "");

    if (phoneNumber.length < 4) {
      setFormProfileData({ ...formProfileData, [e.target.name]: phoneNumber });
      return;
    }

    if (phoneNumber.length < 7) {
      setFormProfileData({
        ...formProfileData,
        [e.target.name]: `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`,
      });
      return;
    }

    setFormProfileData({
      ...formProfileData,
      [e.target.name]: `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(
        3,
        6
      )}-${phoneNumber.slice(6, 10)}`,
    });
    setError((prevState:any) => ({...prevState, 'phone': ""}));
    return;
  };

  const makeSocialSecurity = (e: any) => {
    
    let temp = hideSocialSecurity.replace(
      hideSocialSecurity.substring(0, 5),
      "*".repeat(hideSocialSecurity.substring(0, 5).length)
    );
    var currentValue = e.target.value.replace(/[^\d*]/g, "");
    var finalValue = "";
    if (hideSocialSecurity.length < currentValue.length) {
      finalValue = hideSocialSecurity
        .concat(currentValue.replace(temp, ""))
        .replace(/[^\d]/g, "");
    } else {
      finalValue = hideSocialSecurity.substring(0, currentValue.length);
    }
    if(finalValue.length===10){
      finalValue= finalValue.substring(0,9)
    }
    setError((prevState:any) => ({...prevState, 'ssn': ""}));
    SetHideSocialSecurity(finalValue);
    setFormProfileData((prevState:any) => ({...prevState, [e.target.name]: hideFormatSSN(finalValue)}));
  };

  const onProfileDataChangeHandler = (event:any) => {
    const {name, value} = event.target;
    setError((prevState:any) => ({...prevState, [name]: ""}));
    setFormProfileData((prevState:any) => ({...prevState, [name]: value}));
  }

  const onAddressDataChangeHandler = (event:any) => {
    const {name, value} = event.target;
    setError((prevState:any) => ({...prevState, [name]: ""}));
    setFormAddressData((prevState:any) => ({...prevState, [name]: name !=='zipCode'?value:formatZipcode(event)}));
  }

  const onDobChangeHandler = (dob: any) =>{
    setError((prevState:any) => ({...prevState, 'dob': ""}));
    setFormProfileData((prevState:any) => ({...prevState, 'dob': dayjs(dob).format('YYYY-MM-DD').toString()}));
  }

  const submiClientProfile = async () => {
    let _error = error;
    formProfileData.firstName === ""?_error["firstName"] = "First Name is mandatory":_error["firstName"] = "";
    formProfileData.lastName === ""?_error["lastName"] = "Last Name is mandatory":_error["lastName"] = "";
    if (formProfileData.phone === "")
      _error["phone"] = "Please provide Phone Number.";
    else if (formProfileData.phone.length < 14)
      _error["phone"] = "Phone has invalid number of characters.";
    !formAddressData.streetAddress1?_error["streetAddress1"] = "Steert Address 1 is mandatory":_error["streetAddress1"] = "";
    !formAddressData.city?_error["city"] = "City is mandatory":_error["city"] = "";
    !formAddressData.state?_error["state"] = "State is mandatory":_error["state"] = "";
    console.log(formAddressData.zipCode);
    if (!formAddressData.zipCode){
      _error["zipCode"] = "Please provide ZIP Code.";
    }
    else if (formAddressData.zipCode.length < 5 ||
          (formAddressData.zipCode.length > 5 && formAddressData.zipCode.length < 10))
      _error["zipCode"] = "ZIP Code has invalid number of characters.";
    
    if (hideSocialSecurity === "")
      _error["ssn"] = "SSN is mandatory";
    else if (hideSocialSecurity.length !== 9)
        _error["ssn"] = "SSN requires 9 Characters";
    else 
      _error["ssn"] = "";
    console.log(formProfileData.dob);
    if(formProfileData.dob){
      let date = moment(formProfileData.dob);
      if (date.format("YYYY-MM-DD") > pstCurrentDate.format("YYYY-MM-DD")) {
        _error["dob"] = "You must be 18 years of age or older.";
      }else {
        _error["dob"] = "";
      }

    }else{
      _error["dob"] = "Date of Birth is Manadatory";
    }
    setError(_error);
    setError({ ...error });
    const anyErrors = Object.values(_error).filter(value => value !== "");
    console.log(anyErrors);
    if(anyErrors.length > 0){
      return;
    }
    setLoading(true);
    const profileId = await userProfileData();
    const profileVariables = {
      ...profileInfo,
      FirstName: formProfileData.firstName,
      MiddleName: formProfileData.middleName,
      LastName: formProfileData.lastName,
      Phone: formProfileData.phone.replace(/[^0-9]/g, ""),
      Ssn: hideSocialSecurity.replaceAll("-", ""),
      Birthdate: formProfileData.dob
    };
    client
      .mutate({ mutation: UpdateProfile, variables: profileVariables })
      .then((res: any) => {
        if (res.data.UpdateProfile) {
          
        }
      })
      .catch((error: any) => {
        console.log(error);
    });
    
    const addressVariables = {
      ...addressInfo,
      ProfileId: profileId,
      State: formAddressData.state,
      City: formAddressData.city,
      StreetAddress1: formAddressData.streetAddress1,
      ZipCode: formAddressData.zipCode,
      StreetAddress2: formAddressData.streetAddress2 ? formAddressData.streetAddress2 : null,
    };
    client
      .mutate({ mutation: UpsertProfilePrimaryAddress, variables: addressVariables })
      .then((res: any) => {
        if (res.data.UpsertProfilePrimaryAddress) {
          createEnrollment();
        }
      })
      .catch((error: any) => {
        setLoading(false);        
      });
  };

  const createEnrollment = async () => {
    const profileId = await userProfileData();
    const variables = {
      EnrollmentId: enrollmentId,
      Name: "InformationCompleted",
      EnrollmentProfiles: [
        {
          EnrollmentId: enrollmentId,
          ProfileId: profileId,
          Owner: true
        }
      ]
    };

    client
      .mutate({ mutation: createEnrollmentAction, variables: variables })
      .then((res: any) => {
        if (res.data.CreateEnrollmentAction) {
          setNextFormId(
            res.data.CreateEnrollmentAction.Enrollment?.NextForm?.Id
          );
          setS3Key(res.data.CreateEnrollmentAction.Enrollment?.NextForm?.S3Key);
          setS3Bucket(
            res.data.CreateEnrollmentAction.Enrollment?.NextForm?.S3Bucket
          );
          setLoading(false);
          next();
        }
      })
      .catch((error: any) => {
        setLoading(false);
      });
  };

  return (
    <>
    <div className="page-container">
    <Box
      sx={{
        alignItems: "flex-center",
        p: { xs: 2, md: 6, lg: 4 },
        m: { xs: 2, md: 6, lg: 4 },
      }}
    >
      <Box
        sx={{
          alignItems: "flex-center",
          pl: { xs: 2, md: 6, lg: 4 },
          pr: { xs: 2, md: 6, lg: 4 },
        }}
      >
        <Button
          variant="text"
          sx={{ color: "#212636", p: 0 }}
          onClick={previous}
        >
          {" "}
          <ArrowBack fontSize="small" /> Back
        </Button>
        <Typography variant="h5" sx={{ mt: 2 }}>
          Review Your Information
        </Typography>
      </Box>
      {loading? <Loading /> :
      <Box
        sx={{
          p: 3,
          m: 4,
          mt:1,
          border: "1px solid var(--mui-palette-divider)",
          borderRadius: 1,
        }}
      >
        <Stack spacing={4}>
          <Stack spacing={3}>
            <Stack>
              <Typography variant="body2">
              We are committed to providing a safe and secure environment. We safeguard your info by encrypting it while we store it in our system. We use SSL encryption when sending your tax returns to the IRS or state agency.
              </Typography>
            </Stack>
            <Grid container spacing={3}>
                <Grid item md={4} xs={12}>
                    <FormControl fullWidth>
                        <InputLabel required>First Name</InputLabel>
                        <OutlinedInput name="firstName" value={formProfileData.firstName} onChange={onProfileDataChangeHandler}/>
                    </FormControl>
                    {error.firstName && (
                        <Message type="error" message={error.firstName}></Message>
                    )}
                </Grid>
                <Grid item md={4} xs={12}>
                    <FormControl fullWidth>
                        <InputLabel>Middle Name</InputLabel>
                        <OutlinedInput name="middleName" value={formProfileData.middleName} onChange={onProfileDataChangeHandler}/>
                    </FormControl>
                </Grid>
                <Grid item md={4} xs={12}>
                    <FormControl fullWidth>
                        <InputLabel required>Last Name</InputLabel>
                        <OutlinedInput name="lastName" value={formProfileData.lastName} onChange={onProfileDataChangeHandler}/>
                    </FormControl>
                    {error.lastName && (
                        <Message type="error" message={error.lastName}></Message>
                    )}
                </Grid>
                <Grid item md={6} xs={12}>
                    <FormControl fullWidth>
                        <InputLabel required>Email Address</InputLabel>
                        <OutlinedInput name="email" value={formProfileData.email} onChange={onProfileDataChangeHandler} disabled={true}/>
                    </FormControl>
                </Grid>
                <Grid item md={6} xs={12}>
                    <FormControl fullWidth>
                        <InputLabel required>Phone Number</InputLabel>
                        <OutlinedInput name="phone" value={formProfileData.phone} onChange={formatPhoneNumber}/>
                    </FormControl>
                    {error.phone && (
                        <Message type="error" message={error.phone}></Message>
                    )}
                </Grid>
            </Grid>
          </Stack>
          <Stack spacing={3}>
            <Stack>
              <Typography variant="body2">
              Please confirm that your address matches the one on your most recent tax return or IRS notice.
              </Typography>
            </Stack>
            <Grid container spacing={3}>
                <Grid item md={12} xs={12}>
                    <FormControl fullWidth>
                        <InputLabel required>Street Address</InputLabel>
                        <OutlinedInput name="streetAddress1" placeholder="Street number, etc" value={formAddressData.streetAddress1} onChange={onAddressDataChangeHandler}/>
                    </FormControl>
                    {error.streetAddress1 && (
                        <Message type="error" message={error.streetAddress1}></Message>
                    )}
                </Grid>
                <Grid item md={12} xs={12}>
                    <FormControl fullWidth>
                        <InputLabel>{'Street Address 2 (Optional)'}</InputLabel>
                        <OutlinedInput name="streetAddress2" placeholder="Street number, etc" value={formAddressData.streetAddress2} onChange={onAddressDataChangeHandler}/>
                    </FormControl>
                </Grid>
                <Grid item md={6} xs={12}>
                    <FormControl fullWidth>
                        <InputLabel required>City</InputLabel>
                        <OutlinedInput name="city" value={formAddressData.city} onChange={onAddressDataChangeHandler}/>
                    </FormControl>
                    {error.city && (
                        <Message type="error" message={error.city}></Message>
                    )}
                </Grid>
                <Grid item md={6} xs={12}>
                    <FormControl fullWidth>
                        <InputLabel required>State</InputLabel>
                        <Select name="state" value={formAddressData.state?formAddressData.state:''} onChange={onAddressDataChangeHandler}>
                          <Option value="">-</Option>
                            {US_STATES.map((state) => {
                              return (
                                <MenuItem value={state.abbreviation}>{state.name}</MenuItem>
                              );
                            })}
                        </Select>
                    </FormControl>
                    {error.state && (
                        <Message type="error" message={error.state}></Message>
                    )}
                </Grid>
                <Grid item md={4} xs={12}>
                    <FormControl fullWidth>
                        <InputLabel required>Zip code</InputLabel>
                        <OutlinedInput name="zipCode" value={formAddressData.zipCode} onChange={onAddressDataChangeHandler}/>
                    </FormControl>
                    {error.zipCode && (
                        <Message type="error" message={error.zipCode}></Message>
                    )}
                </Grid>
            </Grid>
          </Stack>
          <Stack spacing={3} sx={{mb: 2}}>
            <Stack>
              <Typography variant="body2">
              Additional information
              </Typography>
            </Stack>
            <Grid container spacing={3}>
                <Grid item md={4} xs={12}>
                    <BasicDateField value={formProfileData.dob} onDateSelect={onDobChangeHandler}/>
                    {error.dob && (
                        <Message type="error" message={error.dob}></Message>
                    )}
                </Grid>
                <Grid item md={4} xs={12}>
                    <FormControl fullWidth>
                        <InputLabel required>{'Social Security Number (SSN)'}</InputLabel>
                        <OutlinedInput name="ssn" value={formProfileData.ssn} onChange={makeSocialSecurity}/>
                    </FormControl>
                    {error.ssn && (
                        <Message type="error" message={error.ssn}></Message>
                    )}
                </Grid>
            </Grid>
          </Stack>
        </Stack>
        <Box className="d-flex justify-content-end">
          <Button className="me-2 text-button" onClick={() => setCurrentStep(0)}>Cancel</Button>
          <Button onClick={submiClientProfile} className="option-primary-button">
            Continue
          </Button>
        </Box>
      </Box>
      }
    </Box>
    </div>
    <div className="my-2">
    <Footer/>
    </div>
    </>
  );
};

export default ProfileInformation;
